import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import booksAPI from '../../sources/api/booksAPI';

// constants
import { BOOKS_FETCH } from '../../constants/booksTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { bookListSchema } from '../../schemas/Normalizr';
import { booksListClear } from '../../actions/booksActions';

export function* booksFetch(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload

  try {
    yield put(booksListClear());
    yield *httpSaga(BOOKS_FETCH, call(booksAPI.all, params), bookListSchema);
  } catch (e) {
    yield put(error(BOOKS_FETCH, e));
  } finally {
    yield put(doneIndicator(BOOKS_FETCH));
  }
}

export function* watchBooksFetch() {
  yield takeEvery(BOOKS_FETCH, booksFetch);
}

export default function* root() {
  yield all([
    fork(watchBooksFetch)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/books/booksFetch.js